import _ from 'lodash';
import { createSelector } from 'reselect';
import FormCollection from './form-collection';

const _scopedState = (state) => state.entities.form;
const _formsById = (state) => _scopedState(state).byId;

const forms = createSelector(_formsById, (formsById) => FormCollection.create(_.values(formsById)));

const isFetching = (state) => _scopedState(state).isFetching;

const formById = (state, formId) => _formsById(state)[formId];

const formsOrdered = createSelector(
  [forms, (state, param) => param, (state, param, dir = 'asc') => dir],
  (forms, param, dir) => _.orderBy(forms, [(form) => form[param].toLowerCase()], dir)
);

const apiErrorMessage = (state) => _scopedState(state).apiErrorMessage;
const isSaving = (state) => _scopedState(state).isSaving;
const isSaveSuccess = (state) => _scopedState(state).isSaveSuccess;
const isSaveError = (state) => _scopedState(state).isSaveError;

const makeFindFormById = (id) => createSelector(forms, (forms) => FormCollection.findById(id, forms));

const makeFindFormsByIds = (ids) =>
  createSelector(_formsById, (formsById) =>
    FormCollection.create(_.values(_.filter(formsById, (f) => ids.indexOf(f.id) > -1)))
  );

export default {
  forms,
  formById,
  formsOrdered,
  makeFindFormsByIds,
  isFetching,
  apiErrorMessage,
  isSaving,
  isSaveSuccess,
  isSaveError,
  makeFindFormById,
};
